// draggableNode.js

export const DraggableNode = ({ type, label }) => {
  const onDragStart = (event, nodeType) => {
    const appData = { nodeType }
    event.target.style.cursor = 'grabbing';
    event.dataTransfer.setData('application/reactflow', JSON.stringify(appData));
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div
      className={type}
      onDragStart={(event) => onDragStart(event, type)}
      onDragEnd={(event) => (event.target.style.cursor = 'grab')}
      draggable
    >
      <div className="
          cursor-grab 
          min-w-[80px] 
          h-[40px] 
          flex 
          items-center 
          justify-center 
          rounded-lg 
          bg-white border border-light-border text-gray-700
          hover:shadow-md hover:border-primary/50 hover:text-primary
          dark:bg-dark-surface dark:border-white/5 dark:text-gray-300
          dark:hover:border-primary dark:hover:shadow-glow dark:hover:text-primary-light
          transition-all 
          duration-200
          text-xs
          font-medium
        ">
        {label}
      </div>
    </div>
  );
};
